const setFullSize = (gameWrapperRef, iframeRef) => {
    setTimeout(() => {
        gameWrapperRef.style.width = '100%';
        gameWrapperRef.style.height = '100%';
        iframeRef.style.top = '0';
        iframeRef.style.height = '100%';
    }, 200);
};

const setIframeFullScreenSize = (iframeRef, topGameControlsRef) => {
    setTimeout(() => {
        iframeRef.style.top = `${topGameControlsRef.offsetHeight}px`;
        iframeRef.style.height = `${window.innerHeight - topGameControlsRef.offsetHeight}px`;
    }, 200);
};

const requestElementFullScreen = async (el) => {
    try {
        if (!document.fullscreenElement) {
            await el.requestFullscreen();
        }
    } catch (e) {
        console.log(`Attempting to enable fullscreen mode: ${e}`);
    }
};

const setLandscapeFullScreen = async (gameWrapperRef) => {
    await requestElementFullScreen(gameWrapperRef);
    await window.screen.orientation.lock('landscape');
};

const exitFullScreen = async () => {
    if (document.fullscreenElement !== null) {
        await document.exitFullscreen();
    }
    await window.screen.orientation.unlock();
};

export const setFullScreenDimensions = async (
    mobilegameformat,
    isLandscape,
    isFullScreen,
    gameWrapperRef,
    topGameControlsRef,
    iframeRef
) => {
    if (isFullScreen) {
        mobilegameformat === 'vertical' ?
            await requestElementFullScreen(gameWrapperRef) :
            await setLandscapeFullScreen(gameWrapperRef);
        setIframeFullScreenSize(iframeRef, topGameControlsRef);
    } else {
        await exitFullScreen();
        setFullSize(gameWrapperRef, iframeRef);
    }
};

const setGameWrapperFullWindowSize = (gameWrapperRef) => {
    setTimeout(() => {
        gameWrapperRef.style.width = `${window.innerWidth}px`;
        gameWrapperRef.style.height = `${window.innerHeight}px`;
        gameWrapperRef.style.transform = 'unset';
    }, 200);
};

export const setFullSizeDimensions = (
    mobilegameformat,
    isLandscape,
    isFullScreen,
    gameWrapperRef,
    topGameControlsRef,
    iframeRef
) => {
    if (isFullScreen) {
        if (mobilegameformat === 'vertical' || isLandscape) {
            setGameWrapperFullWindowSize(gameWrapperRef);
            setIframeFullScreenSize(iframeRef, topGameControlsRef);
        } else if (mobilegameformat !== 'vertical' && !isLandscape) {
            setTimeout(() => {
                const translateShift = (window.innerHeight - window.innerWidth) / 2;

                gameWrapperRef.style.width = `${window.innerHeight}px`;
                gameWrapperRef.style.height = `${window.innerWidth}px`;
                gameWrapperRef.style.transform = `rotate(90deg) translate(${translateShift}px, ${translateShift}px)`;
                iframeRef.style.top = `${topGameControlsRef.offsetHeight}px`;
                iframeRef.style.height = `${window.innerWidth - topGameControlsRef.offsetHeight}px`;
            }, 200);
        }
    } else {
        if (isLandscape) {
            setGameWrapperFullWindowSize(gameWrapperRef);
            iframeRef.style.top = '0';
            iframeRef.style.height = '100%';
        } else {
            setFullSize(gameWrapperRef, iframeRef);
            gameWrapperRef.style.transform = 'unset';
        }
    }
};
